import { isEmpty } from 'rambda';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import type { SearchFriend } from '@/hooks/search/use-search-friends';
import ROUTES from '@/routes';
import cn from '@/utils/merge-class-names';
import SearchFriendResultItem from './search-friend-result-item';

interface Props {
  friends: SearchFriend[];
  keyword?: string;
  className?: string;
}

export default function SearchFriendResultList({ friends, className }: Props) {
  const { t } = useTranslation();

  if (isEmpty(friends)) return null;

  return (
    <div className={cn('group/friend', className)}>
      <h4 className='flex h-6 mb-2 group-first/friend:mt-1 items-center px-5 text-body1 font-bold'>
        {t('conversation.contact.contact')}
      </h4>

      {friends.map((friend) => {
        const { FriendID } = friend;
        return (
          <Link
            key={FriendID}
            to={ROUTES.CONTACT.USERS.BY_ID.$buildPath({ params: { userId: FriendID } })}>
            <SearchFriendResultItem {...friend} />
          </Link>
        );
      })}
    </div>
  );
}
